import { NgModule } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {BrowserModule} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppCommonModule } from "./common/common.module";
import { ComponentsModule } from "./components/components.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { LineElement, PointElement, ArcElement, CategoryScale, LinearScale, Title, Tooltip, Legend, Chart } from 'chart.js';
Chart.register(
  LineElement,
  PointElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);
// import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
// import { BrowserStateInterceptor } from "./utils/browserstate.interceptor";

@NgModule({
  declarations: [AppComponent],
  imports: [
    // BrowserModule.withServerTransition({ appId: "serverApp" }),
    BrowserModule,
    // BrowserTransferStateModule,
    // BrowserAnimationsModule,
    AppRoutingModule,
    AppCommonModule,
    ComponentsModule,
    NgbModule
  ],
  // entryComponents: [],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    // provideCharts(withDefaultRegisterables()),
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: BrowserStateInterceptor,
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
